const faqs = [
  {
    q: 'UU漫画提供哪些类型的漫画资源？',
    a: 'UU漫画覆盖韩漫推荐、日漫大全、国漫排行榜等热门漫画类型，涵盖热血、恋爱、悬疑、奇幻、搞笑、校园、古风等数十种分类，无论你喜欢哪种风格，都能在这里找到心仪的作品。',
  },
  {
    q: '如何快速找到适合自己的漫画？',
    a: '你可以通过首页的热门榜单、编辑精选和类型索引快速浏览当前最受欢迎的作品，也可以按话题标签或分类进行筛选。我们的推荐算法会根据热门程度和更新频率帮你锁定好看的漫画。',
  },
  {
    q: 'UU漫画的内容更新频率是怎样的？',
    a: '平台每日稳定更新300+章节，韩漫、日漫、国漫均有专人跟进最新连载。热门作品会在更新后第一时间同步，让你不错过任何精彩剧情。',
  },
  {
    q: '使用UU漫画需要注册或付费吗？',
    a: 'UU漫画是免费漫画大全平台，所有内容导航和推荐均可免费使用，无需注册即可浏览全部功能。我们致力于为漫画爱好者提供便捷、高效的找漫体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">常见问答</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">关于UU漫画，你想知道的都在这里</p>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-100 rounded-lg border border-background-200/70">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">{faq.q}</h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line" />
                </span>
                <span className="w-6 h-6 items-center justify-center flex-shrink-0 text-primary-500 hidden group-open:flex">
                  <i className="ri-subtract-line" />
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}